import { useQuery } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_MFA_SETUP_TOTP } from "consts";

export default function useMfaSoftwareTokenQuery(accessToken, enabled, config) {
  return useQuery(
    ["mfaSoftwareToken", accessToken],
    () => postWithBearer(API_MFA_SETUP_TOTP, {}, accessToken),
    {
      enabled: Boolean(accessToken) && enabled,
      retry: 1,
      ...config,
    }
  );
}
